
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import { deleteYukbulBlockingMessage } from "../../../features/admin5/admin5Slice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: auto;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            max-height: 500px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 40px 60px;
            margin: 20px 0;
            width: 100%;
            gap: 40px;
            overflow: auto;

            .desc{
                color: ${({theme}) => theme.mainTextColor};
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }

            .btn-container{
                display: flex;
                gap: 30px;
            }
            
        }
    }
`

const blockTypeOptions = [
    {
      value: 1,
      text: "Yazı Engelle"
    },
    {
      value: 2,
      text: "Telefon Numarasına Ait Mesajları Engelle"
    },
  ]

const DeleteYukbulBlockingMessageConfirmModal = () => {
    
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)

    const {
        blockingMessageFilterItem,
        isLoadingDeleteYukbulBlockingMessage
    } = useSelector(state => state.admin5)


    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {
        dispatch(deleteYukbulBlockingMessage(blockingMessageFilterItem.id))
    }

 
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))} >
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                <p className="desc">
                    {
                        blockingMessageFilterItem.filterType === 1 ? `Onayladığınız halde "${blockingMessageFilterItem.filterValue}" yazısı içeren mesajların engeli kalkacaktır.`: `Onayladığınız halde "${blockingMessageFilterItem.filterValue}" telefon numarasının yazmış olduğu mesajların engeli kalkacaktır.`
                    }
                </p>
                <div className="btn-container">
                    <Btn bgColor="#E85446" color="#fff" handleClick={handleSubmit} width={"220px"}>{isLoadingDeleteYukbulBlockingMessage ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Onayla ve Sil"}</Btn>
                    <Btn color="#E85446" bgColor="transparent" width={"220px"} handleClick={()=> dispatch(showModal(null))}>Geri Dön</Btn>
                </div>
            </div>
        </div>
    </ModalContainer>
  )
}

export default DeleteYukbulBlockingMessageConfirmModal